export default __webpack_public_path__ + "static/media/tela_maxoutsource.e3720432.png";